import type { TaskGroup } from "@/hooks/api/use-milestone-analyses";

interface MilestoneAnalysesBadgeProps {
  milestoneTasks?: TaskGroup[];
  isAdminFeaturesEnabled?: boolean;
}

/**
 * A badge component that shows the count of available milestone analyses
 */
export function MilestoneAnalysesBadge({
  milestoneTasks,
  isAdminFeaturesEnabled,
}: MilestoneAnalysesBadgeProps) {
  if (!milestoneTasks) return null;

  // Calculate filtered task groups
  const filteredGroups = milestoneTasks.filter((group) => {
    // If admin features are enabled, count all task groups
    if (isAdminFeaturesEnabled) {
      return true;
    }
    // Otherwise, only count groups with at least one approved analysis
    return group.analyses.some((analysis) => analysis.is_approved);
  });

  // Only show badge if there are actual analyses to display
  return filteredGroups.length > 0 ? (
    <div className="ml-1.5 -mt-1 flex items-center justify-center w-4 h-4 bg-primary text-primary-foreground text-[10px] rounded-full">
      {filteredGroups.length}
    </div>
  ) : null;
}
